import axios from 'axios';

export const  axios_compagnies_getall = async ()=>{
    return await axios.get(`/compagnies/getall`,{headers:{ 'Accept': 'application/json', 'Content-Type': 'application/json'   }});
}


export const  axios_compagnies_allcompagniestarifs = async ()=>{
    return await axios.get(`/compagnies/getallcompagniestarifs`,{headers:{ 'Accept': 'application/json', 'Content-Type': 'application/json'   }});
}



const myheaders = { 'Accept': 'application/json','Content-Type':'application/json'}
export const  axios_compagnies_getCourtierCompagniesDatas= async (courtier)=>{
    return await axios({method:'POST',url :`/compagnies/getCourtierCompagniesDatas`,data:{'courtier':courtier},headers:myheaders});
}


